/* Cart milestone widget — keeps the unlocked state in step with the cart.

   Loaded from layout/theme.liquid rather than inlined in the snippet: the cart
   drawer re-renders through innerHTML, and innerHTML does not execute script
   tags, so an inline script would run once and then go dead the first time the
   customer changed a quantity. This is the same reason maahi-cart-recs.js is a
   separate asset.

   PRESENTATIONAL ONLY. It reads /cart.js and rewrites text and classes. It never
   posts to the cart, never touches the Razorpay button, and never runs on any
   page that has no widget on it.

   Every threshold and every string comes from data attributes written by
   snippets/maahi-cart-milestones.liquid, so the copy and the amounts live in one
   place — change them there, not here. */
(function () {
  'use strict';

  function apply(root, totalPaise) {
    var t2 = parseInt(root.getAttribute('data-ms-t2'), 10);
    var t3 = parseInt(root.getAttribute('data-ms-t3'), 10);
    if (isNaN(t2) || isNaN(t3)) return;

    var hit2 = totalPaise >= t2;
    var hit3 = totalPaise >= t3;

    var statusKey = hit3 ? 'data-ms-status-3' : hit2 ? 'data-ms-status-2' : 'data-ms-status-1';
    var statusEl = root.querySelector('[data-ms-status]');
    var statusText = root.getAttribute(statusKey);
    if (statusEl && statusText) statusEl.textContent = statusText;

    /* Step 1 is never touched — the launch discount has no threshold. */
    var step2 = root.querySelector('[data-ms-step="2"]');
    var step3 = root.querySelector('[data-ms-step="3"]');
    if (step2) step2.classList.toggle('is-done', hit2);
    if (step3) step3.classList.toggle('is-done', hit3);

    /* Connector fill: 50% once ₹5,000 is reached, 100% at ₹10,000. */
    var fill = root.querySelector('[data-ms-fill]');
    if (fill) {
      fill.classList.toggle('is-t2', hit2 && !hit3);
      fill.classList.toggle('is-t3', hit3);
    }
  }

  function refresh() {
    var root = document.querySelector('[data-maahi-milestones]');
    if (!root) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        /* total_price is paise and is the pre-coupon total, which is what the
           Razorpay minimum-spend rules are written against. */
        if (!cart || typeof cart.total_price !== 'number') return;
        var current = document.querySelector('[data-maahi-milestones]');
        if (current) apply(current, cart.total_price);
      })
      .catch(function () {
        /* Leave the server-rendered state alone. It was correct when the page
           was built, so a failed refresh shows slightly stale copy at worst —
           never a wrong or broken cart. */
      });
  }

  /* The theme dispatches cart:update on every quantity change, add and remove;
     maahi-cart-recs.js listens to the same event. */
  document.addEventListener('cart:update', refresh);
})();
